import { plainToClass } from 'class-transformer';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class EditForm extends Vue {
    public api: any;
    public formModel: any;
    public saving = false;
    public formErrorSnackbarMsg = 'Veuillez corriger les erreurs et réessayer';
    public entityCreatedMsg = 'Enregistré';
    public entityUpdatedMsg = 'Enregistré';
    public entityCreatedErrorMsg = 'Erreur de création';
    public entityUpdatedErrorMsg = 'Erreur de mise à jour';
    public formModelClass: any;
    public fetchedEntity: any;
    public saveError: any = null;

    public get entityId(): any {
        return undefined;
    }

    public get creation(): boolean {
        return false;
    }

    public async validateForm(): Promise<boolean> {
        await this.formModel.validate();

        if (!this.formModel.isValid) {
            throw new Error();
        }

        return true;
    }

    public async save(): Promise<void> {
        this.saveError = null;
        this.saving = true;
        try {
            await this.validateForm();
        } catch (_) {
            console.error('ERR', _);
            this.$buefy.snackbar.open({
                message: this.formErrorSnackbarMsg,
                type: 'is-danger',
            });
            this.saving = false;
            return;
        }

        try {
            if (this.creation) {
                await this.create();
            } else {
                await this.update();
            }
        } catch (e) {
            this.saveError = e;
        }

        if (!this.saveError) {
            this.$emit('edited');
        }

        this.saving = false;
    }

    public async create(): Promise<void> {
        try {
            await this.api.create(this.formModel.toDto());
            this.$buefy.snackbar.open({
                message: this.entityCreatedMsg,
                type: 'is-success',
            });
        } catch (e) {
            this.$buefy.snackbar.open({
                message: this.entityCreatedErrorMsg,
                type: 'is-danger',
            });

            throw e;
        }
    }

    public async update(): Promise<any> {
        let updateResponse: any;
        try {
            updateResponse = await this.api.update(this.formModel.toDto());
            this.$buefy.snackbar.open({
                message: this.entityUpdatedMsg,
                type: 'is-success',
            });

            return updateResponse;
        } catch (e) {
            console.log('ERR', e);
            this.$buefy.snackbar.open({
                message: this.entityUpdatedErrorMsg,
                type: 'is-danger',
            });

            throw e;
        }
    }

    public async getEntity(): Promise<void> {
        this.fetchedEntity = await this.api.get(this.entityId);
        this.formModel = plainToClass(this.formModelClass, this.fetchedEntity);
        this.formModel.original = this.fetchedEntity;
    }

    public async cancel(): Promise<void> {
        this.$emit('cancel');
    }
}
